module.exports = __webpack_public_path__ + "xxgg.png?0442e632c705bd307bfd265f16f74afe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xxgg.png
// module id = 670
// module chunks = 0